{
  "EMAIL_TEMPLATE_NOT_FOUND": "No se encontró la plantilla de email",
  "EMAIL_TEMPLATE_DEFAULT_NOT_FOUND": "No hay contenido predeterminado para \"{{slug}}\"",
  "EMAIL_TEMPLATE_SLUG_TAKEN": "Ya existe una plantilla con el slug \"{{slug}}\" en este idioma",
  "EMAIL_TEMPLATE_LANGUAGE_INVALID": "El idioma de la plantilla no es válido"
}
